const FILES = {
  win: 'you-win-perfect.mp3',
  pairWin: 'pair-win.mp3',
  fail: 'spongebob-fail.mp3',
};

const players = {};

function getPlayer(kind) {
  if (!players[kind]) {
    const audio = new Audio(`${process.env.PUBLIC_URL}/sounds/${FILES[kind]}`);
    audio.preload = 'auto';
    audio.setAttribute('playsinline', '');
    audio.addEventListener('ended', () => {
      audio.pause();
      audio.currentTime = 0;
    });
    players[kind] = audio;
  }
  return players[kind];
}

export function playResultSound(kind) {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
    return;
  }
  stopResultSounds();
  const audio = getPlayer(kind);
  audio.currentTime = 0;
  audio.play().catch(() => {});
}

export function stopResultSounds() {
  Object.keys(players).forEach((kind) => {
    const audio = players[kind];
    audio.pause();
    audio.currentTime = 0;
  });
}

function disposeResultSounds() {
  Object.keys(players).forEach((kind) => {
    const audio = players[kind];
    audio.pause();
    audio.removeAttribute('src');
    try {
      audio.load();
    } catch (_) {
      // Safari can throw if the element is already torn down
    }
    delete players[kind];
  });
}

if (typeof window !== 'undefined') {
  const halt = () => disposeResultSounds();
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') halt();
  });
  window.addEventListener('pagehide', halt);
  window.addEventListener('freeze', halt);
}
